import FileDimensions from '../Types/FileDimensions';

import Model from './Model';
import Page from './Page';

export default class SliderItem extends Model {
    readonly id: number;
    readonly slider_id: number;
    readonly lottery_id: number | null = null;
    readonly language_id: number = 1;
    readonly type: string = 'url';
    readonly image_url: string;
    readonly mobile_image_url: string | null = null;
    readonly redirection_url: string;
    readonly page_id: number | null = null;
    readonly page_parameters: Record<string, string | number> | null = null;
    readonly page: Page | null = null;
    readonly alt_value: string | null = null;

    readonly image_dimensions: FileDimensions | null = null;
    readonly mobile_image_dimensions: FileDimensions | null = null;
    readonly lottery: {
        title: string;
        url: string;
        amount: string;
    } | null = null;

    constructor(data: any) {
        super();

        this.assignDataToProps(data, [
            'id',
            'slider_id',
            'language_id',
            'type',
            'image_url',
            'mobile_image_url',
            'redirection_url',
            'page_id',
            'page_parameters',
            'alt_value',
            'lottery_id',
            'image_dimensions',
            'mobile_image_dimensions',
            'lottery',
        ]);

        this.page = data.page ? new Page(data.page) : null;
    }
}
